module.exports = __webpack_public_path__ + "static/media/TICKET HOSS ONE LINE.ff836558.svg";